module.exports = __webpack_public_path__ + "img/banner-cumplimiento.e4a769b1.jpg";